import {assign, mapValues, forEach} from 'lodash'

const stylePropertiesToCleanInReattach = {}

export const setDetachedItemCssOverrides = (cssOverrides: {[prop: string]: string}, compId: string, windowObject: Window) => {
    const node = windowObject.document.getElementById(compId)
    assign(node.style, cssOverrides)

    stylePropertiesToCleanInReattach[compId] = stylePropertiesToCleanInReattach[compId] || {}
    assign(stylePropertiesToCleanInReattach[compId], mapValues(cssOverrides, () => true))
}

export const clearAllDetachedItemsCssOverrides = (windowObject: Window) => {
    forEach(stylePropertiesToCleanInReattach, (compStylePropertiesToClean, compId) => {
        const node = windowObject.document.getElementById(compId)

        if (node) {
            // @ts-ignore
            forEach(compStylePropertiesToClean, (v, propKey) => node.style.removeProperty(propKey))

            if (node.getAttribute('style') === '') {
                node.removeAttribute('style')
            }
        }

        delete stylePropertiesToCleanInReattach[compId]
    })
}
